import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import {
  DownloadOutlined,
  EyeOutlined,
  FileDoneOutlined,
  HistoryOutlined,
  MoreOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";
import {
  Button,
  Dropdown,
  Form,
  Layout,
  MenuProps,
  message,
  Space,
  TableColumnsType,
  TableProps,
  Tabs,
  TabsProps,
} from "antd";
import { isEmpty } from "lodash";
import React, { ChangeEvent, KeyboardEvent, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FormFilter from "../../../../components/course-browse/course-evaluation/filter-group/FormFilter";
import FilterDataCourseBrowse from "../../../../components/course-browse/course-evaluation/filter-table/FilterTable";
import PageHeader from "../../../../components/page-header/PageHeader";
import TableData from "../../../../components/table-data/TableData";
import { routesConfig } from "../../../../config/routes";
import { assignMultiCourse, revokeAssign, } from "../../../../service/assign-course-construction";
import { getCourseReviewList } from "../../../../service/course-construct";
import { formatOriginTime, formatOriginTimev3 } from "../../../../utils/converDate";
import "./index.scss";
import ReviewMultipleContent from "../../../../components/modal/review-multiple-content";

type Props = {
  title?: string;
};

const CourseEvaluation = (props: Props) => {
  const { t } = useTranslation();
  const [tab, setTab] = useState("1");
  const { title } = props;
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [courseReviewList, setCourseReviewList] = useState([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [quickReview, setQuickReview] = useState(false)
  const [clearRowkey, setClearRowkey] = useState<boolean>(false);

  const [pageSize, setPageSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [countReviewed, setCountReviewed] = useState<number>(0);
  const [countAwaitingReview, setCountAwaitingReview] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [clearForm, setClearForm] = useState<boolean>(false);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [quickReviewId, setQuickReviewId] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const [filterData, setFilterData] = useState<any>({
    status: null,
    courseType: null,
    approvedDate: null,
  });

  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const handleOpenCreate = () => {
    if (isEmpty(selectedRowKeys)) {
      message.error(t("Vui lòng chọn khoá học phân công", "Vui lòng chọn khoá học phân công"));
      return;
    }
    setIsOpened(true);
  };

  const formatDateWithTime = (dateString: string | null): string | null => {
    if (!dateString) return null;
    const [day, month, year] = dateString.split('-');
    const formattedDate = `${year}-${month}-${day}`;
    return `${formattedDate}T00:00:00.000Z`;
  }
  const getListData = () => {
    setLoading(true);
    const approvedDate = filterData.approvedDate?.filter((item: any) => !!item);
    const data = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue.trim() || undefined,
      apprisedSendFrom: !isEmpty(filterData.approvedDate) && !isEmpty(filterData.approvedDate?.[0]) ? formatDateWithTime(approvedDate[0]) : null,
      apprisedSendTo: !isEmpty(filterData.approvedDate) && !isEmpty(filterData.approvedDate?.[1]) ? formatDateWithTime(approvedDate[1]) : null,
      courseType: filterData.courseType ? filterData.courseType : [],
      status: filterData.status === 1 || tab === '2',
      sort: statusOrder ? [`${statusOrder}`] : [],
    };

    getCourseReviewList(data)
      .then((res) => {
        const { data } = res;
        setCourseReviewList(data?.page?.content);
        setTotalRecords(data.totalElements);
        setCountReviewed(data?.countTrueRecords);
        setCountAwaitingReview(data?.countFalseRecords);

        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (location.state?.tab) {
      setTab(location.state?.tab);
    }
  }, [navigate]);

  useEffect(() => {
    getListData();
  }, [tab, pageNumber, statusOrder, pageSize]);

  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const handleSubmitSearch = () => {
    getListData();
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      getListData();
    }
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
  };

  const handleCloseFilter = () => {
    setShowFilter(false);
  };

  const clearFilter = () => {
    // setLoading(true)
    form.resetFields();
    setFilterData({
      status: null,
      courseType: null,
      approvedDate: null,
    });
  };

  const revocationAssignment = async (record: any) => {
    await revokeAssign(record.id).then((res) => {
      if (res.status === 200) {
        message.success(t("Lưu thông tin thành công", "Lưu thông tin thành công"));
        setTab("1");
      }
    });
  };

  const handleReturnCourseType = (courseType: number) => {
    switch (courseType) {
      case 1:
        return t("Tự triển khai", "Tự triển khai");
      case 2:
        return t("Hợp tác xây dựng", "Hợp tác xây dựng");
      case 3:
        return t("Dùng chung", "Dùng chung");
      default:
        return "";
    }
  };

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "courseName,asc"
        : sorter.order === "descend"
          ? "courseName,desc"
          : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  const optionsMenu: MenuProps["items"] = [
    {
      key: "1",
      label: t("Thẩm định khoá học", "Thẩm định khoá học"),
      icon: <FileDoneOutlined />,
    },
    {
      key: "2",
      label: t("Thẩm định nhanh nội dung", "Thẩm định nhanh nội dung"),
      icon: <ThunderboltOutlined />,
    },
    // {
    //   key: "3",
    //   label: t("Lịch sử thẩm định", "Lịch sử thẩm định"),
    //   icon: <HistoryOutlined />,
    // },
    // {
    //   key: "4",
    //   label: t("Tải nội dung khoá học", "Tải nội dung khoá học"),
    //   icon: <DownloadOutlined />,
    // },
    {
      key: "5",
      label: t("Kết quả duyệt", "Kết quả duyệt"),
      icon: <ThunderboltOutlined />,
    },
  ];

  const optionsAppraisedMenu: MenuProps["items"] = [
    {
      key: "5",
      label: t("Lịch sử thẩm định", "Lịch sử thẩm định"),
      icon: <HistoryOutlined />,
    },
    {
      key: "6",
      label: t("Tải nội dung khoá học", "Tải nội dung khoá học"),
      icon: <DownloadOutlined />,
    },
  ];

  const dataColumns: TableColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 10,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Mã khoá học", "Mã khoá học"),
      dataIndex: "code",
      key: "code",
      width: 20,
    },
    {
      title: t("Tên khoá học", "Tên khoá học"),
      dataIndex: "courseName",
      key: "courseName",
      sorter: true,
      width: 30,
      render: (_: any, record: any) => {
        return (
          <div className="table-order-course-name">
            <img
              className="item-carousel__image"
              loading="eager"
              alt=""
              src={record?.image || "/images/ic_school_placeholder.svg"}
            />
            <div>
              <span className="course-title">{record?.nameCourse}</span>
              <span>{record?.enterpriseName}</span>
            </div>
          </div>
        );
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      dataIndex: "status",
      key: "status",
      shouldCellUpdate(record, prevRecord) {
        return true
      },
      width: 20,
      render: (_: any, record) => {
        return (
          <div className="table-order-course-name">
            {tab === "1" ? t("Chờ hội đồng thẩm định duyệt", "Chờ hội đồng thẩm định duyệt") : t("Chờ tổ chuyên môn duyệt", "Chờ tổ chuyên môn duyệt")}
          </div>
        );
      },
    },
    {
      title: t("Loại khoá học", "Loại khoá học"),
      dataIndex: "courseType",
      key: "courseType",
      width: 20,
      render: (_: any, record) => {
        return (
          <div className="table-course-type">
            {record.courseType === 2 ? (
              <div className="table-course-type-2">
                {handleReturnCourseType(record.courseType)}
              </div>
            ) : record.courseType === 1 ? (
              <div className="table-course-type-1">
                {handleReturnCourseType(record.courseType)}
              </div>
            ) : <div className="table-course-type-3">
              {handleReturnCourseType(record.courseType)}
            </div>}
          </div>
        );
      },
    },

    {
      title: t("Ngày gửi thẩm định", "Ngày gửi thẩm định"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: 20,
      render: (_: any, record: any) => {
        return <>{!isEmpty(record?.createdDate) ? formatOriginTimev3(record?.createdDate) : null}</>;
      },
    },
    {
      title: t("Ngày thẩm định", "Ngày thẩm định"),
      dataIndex: "updateDate",
      key: "updateDate",
      width: 20,
      render: (_: any, record: any) => {
        return <>{!isEmpty(record?.updateDate) ? formatOriginTimev3(record?.updateDate) : null}</>;
      },
    },
    {
      title: "",
      dataIndex: "action",
      fixed: "right",
      key: "operation",
      render: (_, record) => {
        const location = {
          id: `${record.id}`,
        };
        return (
          <>
            {
              tab === "1" ?
                <Space>
                  <a
                    className="action-table"
                    onClick={() =>
                      navigate(
                        `${routesConfig.detailCourseEvaluation}/${location.id}`,
                        {
                          state: {
                            ...record,
                            isCourseEvaluation: true,
                            mode: 'view'
                          },
                        }
                      )
                    }
                  >
                    <EyeOutlined />
                  </a>

                  <Dropdown
                    menu={{
                      items: tab === "1" ? optionsMenu : optionsAppraisedMenu,
                      onClick: ({ key }) => {
                        if (key === "3" || key === "5") {
                          navigate(
                            `${routesConfig.detailCourseEvaluation}/${location.id}`,
                            {
                              state: {
                                ...record,
                                isCourseEvaluation: true,
                                tab: 3
                              },
                            }
                          );
                        }
                        if (key === "1") {
                          navigate(
                            `${routesConfig.detailCourseEvaluation}/${location.id}`,
                            {
                              state: {
                                ...record,
                                isCourseEvaluation: true,
                                tab: 2,
                                mode: 'edit'
                              }
                            }
                          );
                        }
                        if (key === "2") {
                          setIsOpened(true)
                          setQuickReview(true)
                          setQuickReviewId(record?.id)
                        }
                      },
                    }}
                    placement="bottomRight"
                  >
                    <Button>
                      <MoreOutlined />
                    </Button>
                  </Dropdown>
                </Space> : <>
                  <Space>
                    <a
                      className="action-table"
                      onClick={() =>
                        navigate(
                          `${routesConfig.detailCourseEvaluation}/${location.id}`,
                          {
                            state: {
                              ...record,
                              isCourseEvaluation: true,
                              mode: 'view'
                            },
                          }
                        )
                      }
                    >
                      <EyeOutlined />
                    </a>
                  </Space>
                </>}
          </>
        );
      },
      width: 10,
    },
  ];

  const defaultCheckedList = dataColumns.map((item) => item.key as string);

  const [checkedList, setCheckedList] = useState(defaultCheckedList);

  const itemsTab: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <div>{t("Chờ thẩm định", "Chờ thẩm định")}<span
            className={`number-record ${tab === "1" ? "number-record-active" : "number-record-disabled"
              }`}
          >
            {countAwaitingReview}
          </span>
        </div>
      ),
      children: (
        <div className="waiting-assignment">
          <TableData
            dataColumns={dataColumns}
            loadingTable={loading}
            dataTable={courseReviewList}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            totalRecords={countAwaitingReview}
            scroll={{ x: 1500, y: 800 }}
            pagination={true}
            hideSelection={true}
            handleTableChangeProps={handleTableChange}
            setSelectedRowKeysProps={setSelectedRowKeys}
            clearRowkey={clearRowkey}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div>{t("Đã thẩm định", "Đã thẩm định")}<span
            className={`number-record ${tab === "2" ? "number-record-active" : "number-record-disabled"
              }`}
          >
            {countReviewed}
          </span>
        </div>
      ),
      children: (
        <div className="assigned">
          <TableData
            dataColumns={dataColumns}
            loadingTable={loading}
            dataTable={courseReviewList}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            totalRecords={countReviewed}
            scroll={{ x: 1500, y: 800 }}
            pagination={true}
            hideSelection={true}
            handleTableChangeProps={handleTableChange}
          />
        </div>
      ),
    },
  ];

  const listBreadcrumb = [
    {
      title: t("Quản trị cơ sở", "Quản trị cơ sở"),
    },
  ];

  const onChange = (key: string) => {
    setTab(key);
    setFilterData({});
    setPageNumber(1);
    form.resetFields();
  };

  const confirmModal = () => {
    message.success(t("Phân công khoá học thành công", "Phân công khoá học thành công"));
    setIsOpened(!isOpened);
  };

  const handleChangeFilter = (value: any, name: string) => {
    setFilterData({ ...filterData, [name]: value });
  };

  const saveMultiAssign = async (data: object) => {
    await assignMultiCourse(data).then((res) => {
      if (res.status === 200) {
        message.success(t("Phân công thành công khoá học", "Phân công thành công khoá học"));
        setIsOpened(!isOpened);
        getListData();
      }
    });
  };

  const statusList = [
    {
      value: "1",
      label: t("Đã xuất bản", "Đã xuất bản"),
    },
  ];

  return (
    <Layout className="page-header-group course-evaluation">
      <Form.Provider
        onFormFinish={(name, { values, forms }) => {
          if (name === "create-course-plan-modal") {
            const listRowKey = selectedRowKeys.map((item: any) => {
              return item.id;
            });
            const data = {
              courseIds: listRowKey,
              assigners: values.lecturerName,
            };
            saveMultiAssign(data);
            getListData();
            setClearForm(true);
          }
          if (name === "filterForm") {
            getListData();
          }
        }}
      >
        <div
          className={`page-header-group--layout ${showFilter ? "open-filter" : ""
            }`}
        >
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader title={title} listBreadcrumb={listBreadcrumb} />
            </div>
            <FilterDataCourseBrowse
              handleOpen={handleOpenCreate}
              searchValue={searchValue}
              dataColumns={dataColumns}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
              handleChangeInput={handleChangeInput}
              selectedRowKeys={selectedRowKeys}
              tab={tab}
            />
          </div>
          <FormFilter
            handleCloseFilter={handleCloseFilter}
            clearFilter={clearFilter}
            form={form}
            showFilter={showFilter}
            tab={tab}
            filterData={filterData}
            setFilterData={handleChangeFilter}
          />
        </div>

        <div className="tabs-heading">
          <Tabs items={itemsTab} activeKey={tab} onChange={onChange} />
        </div>
        <ReviewMultipleContent
          open={isOpened}
          type="thamdinh"
          title={`${quickReview ? t("Thẩm định nhanh", "Thẩm định nhanh") : t("Thẩm định nhiều", "Thẩm định nhiều")} `}
          handleClose={() => setIsOpened(false)}
          quickReview={quickReview}
          quickReviewId={quickReviewId}
          selectedRowKeys={selectedRowKeys}
          getListDataProps={getListData}
          setSelectedRowKeys={() => setSelectedRowKeys([])}
          setClearRowkey={setClearRowkey}
        />
      </Form.Provider>
    </Layout>
  );
};

export default CourseEvaluation;
